<div *ngIf="isDisplayed$() | async">
    <p *ngIf="description">{{description | loadTemplateData$ | async}}</p>

    <mat-chip-set>
        <mat-chip *ngFor="let chip of chips" mat-raised-button (click)="selectChip(chip)" color="accent">
            {{ chip }}
            <mat-icon matChipTrailingIcon *ngIf="hasMultiple">add</mat-icon>
        </mat-chip>
    </mat-chip-set>
</div>